export function formatSlotTime(isoUtc: string): string {
  const d = new Date(isoUtc);
  return d.toLocaleTimeString('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function formatConfirmedDateISO(isoUtc: string): string {
  return new Date(isoUtc).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
}

export function formatConfirmedDayOfWeek(isoUtc: string): string {
  return new Date(isoUtc).toLocaleDateString('en-US', { timeZone: 'America/New_York', weekday: 'long' });
}

export function formatConfirmedTime(startIso: string, endIso: string): string {
  return `${formatSlotTime(startIso)} – ${formatSlotTime(endIso)} ET`;
}

export function formatFullDate(isoUtc: string): string {
  return new Date(isoUtc).toLocaleDateString('en-US', {
    timeZone: 'America/New_York',
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatDayHeader(dateStr: string): { dayOfWeek: string; dateLabel: string } {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
  const dateLabel = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return { dayOfWeek, dateLabel };
}

export function formatHourLabel(hour: number): string {
  if (hour === 0) return '12 AM';
  if (hour < 12) return `${hour} AM`;
  if (hour === 12) return '12 PM';
  return `${hour - 12} PM`;
}

export const CALENDAR_HOURS = Array.from({ length: 14 }, (_, i) => 7 + i);
export const HOUR_HEIGHT = 52;
export const TOTAL_GRID_HEIGHT = CALENDAR_HOURS.length * HOUR_HEIGHT;

export function getSlotStyle(available: number, capacity: number): { bg: string; hoverBg: string; text: string; label: string } {
  if (available === 0) {
    return { bg: 'bg-red-100', hoverBg: '', text: 'text-red-800', label: 'Unavailable' };
  }
  const slotLabel = `${available} of ${capacity} slots available`;
  if (available === capacity) {
    return { bg: 'bg-green-50', hoverBg: 'hover:bg-green-100', text: 'text-green-700', label: slotLabel };
  }
  const pct = available / capacity;
  if (pct <= 0.25) {
    return { bg: 'bg-orange-100', hoverBg: 'hover:bg-orange-200', text: 'text-orange-800', label: slotLabel };
  }
  if (pct <= 0.5) {
    return { bg: 'bg-amber-50', hoverBg: 'hover:bg-amber-100', text: 'text-amber-800', label: slotLabel };
  }
  return { bg: 'bg-yellow-50', hoverBg: 'hover:bg-yellow-100', text: 'text-yellow-800', label: slotLabel };
}
